export var MODE;
(function (MODE) {
  MODE[MODE["Edit"] = 1] = "Edit";
  MODE[MODE["Create"] = 0] = "Create";
})(MODE || (MODE = {}));
export var CGI_TYPE;
(function (CGI_TYPE) {
  CGI_TYPE[CGI_TYPE["NormalHttp"] = 1] = "NormalHttp";
  CGI_TYPE[CGI_TYPE["Gw123Http"] = 2] = "Gw123Http";
  CGI_TYPE[CGI_TYPE["ScfHttp"] = 3] = "ScfHttp";
  CGI_TYPE[CGI_TYPE["Wuji1_0"] = 4] = "Wuji1_0";
  CGI_TYPE[CGI_TYPE["Sql"] = 5] = "Sql";
  CGI_TYPE[CGI_TYPE["Code"] = 6] = "Code";
  CGI_TYPE[CGI_TYPE["FrontEndHttp"] = 7] = "FrontEndHttp";
  CGI_TYPE[CGI_TYPE["CustomGwHttp"] = 8] = "CustomGwHttp";
  CGI_TYPE[CGI_TYPE["ER"] = 9] = "ER";
})(CGI_TYPE || (CGI_TYPE = {}));
export var DNS_TYPE;
(function (DNS_TYPE) {
  DNS_TYPE[DNS_TYPE["DNS"] = 2] = "DNS";
})(DNS_TYPE || (DNS_TYPE = {}));
export var MockDataFormat;
(function (MockDataFormat) {
  MockDataFormat[MockDataFormat["JSON"] = 0] = "JSON";
  MockDataFormat[MockDataFormat["CODE"] = 1] = "CODE";
})(MockDataFormat || (MockDataFormat = {}));
export const AuthType = {
  SIMPLE: 'SIMPLE',
  ANONYMOUS: 'ANONYMOUS'
};
//# sourceMappingURL=ICgiOption.js.map
